export default "__VITE_ASSET__pHsw6hiT__"